module.exports = __webpack_public_path__ + "img/coffee.cb1b16a6.png";